import React from 'react';
import { useTheme } from '@mui/material/styles';
import MonthlySummary from '../../monthlySummary';
import MonthlyCalendar from '../monthlyCalendar';
import Divider from '../../../../../components/divider';
import CommonCard from '../../../../../components/card/CommonCard';

const MonthlyCard = ({
    month,
    year,
    goalDays,
    achievedDays,
    stepCount = -1,
    calories,
    time,
    isCurrentMonth = false,
    isDidim = false,
    onDateClick,
    selectedDate = null,
    monthlyData = {},
    dailyData, // Extract dailyData to prevent it from being passed to DOM
    sx = {},
    ...props
}) => {
    const theme = useTheme();

    return (
        <CommonCard sx={sx} {...props}>
            <MonthlySummary
                month={month}
                goalDays={goalDays}
                achievedDays={achievedDays}
                stepCount={stepCount}
                calories={calories}
                time={time}
                isCurrentMonth={isCurrentMonth}
                isDidim={isDidim}
            />

            <Divider
                lineColor={theme.palette.figma.white[20]}
            />

            <MonthlyCalendar
                currentMonth={month}
                currentYear={year}
                onDateClick={onDateClick}
                selectedDate={selectedDate}
                monthlyData={monthlyData}
                isDidim={isDidim}
            />
        </CommonCard>
    );
};

export default MonthlyCard;
